<template lang="pug">
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/basic
div(class="border-bottom insety-16")
    ib-row
        ib-col(class="xl2 s12")
           p(:class="{'insety-16': $media.xl, 'insetx-8': $media.xl}")
                span(
                    class="insetx-8 info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('select_capitalization') }}
                span {{ $t('market_capitalization') }}
        ib-col(
            class="xl10",
            :class="{ 'inset-16': $media.xl, 'insety-16': $media.s, 'insetx-16': $media.xl, 'insetx-0': !$media.m }"
        )
            div(:class="{ 'flex-flex': !$media.s }", class="button-select")
                ib-button(
                    @click="setAllActive",
                    class="text-left",
                    :class="{active: selectAll}"
                )
                    span {{ $t('select_all') }}
                    span(
                        v-if="selectAll",
                        class="inset-8",
                        :class="{'fg-positive': selectAll}"
                    )
                        +icon-color-yes
                ib-button(
                    v-for="(range, index) in marketCaps",
                    @click="select(index)",
                    class="text-left",
                    :class="{active: range.selected}",
                    :key="index"
                ) 
                    span {{ $t(range.name) }}
                    span(
                        v-if="range.selected",
                        class="inset-8 fg-positive"
                    )
                        +icon-color-yes
</template>

<script>
    import cloneDeep from 'lodash.clonedeep';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'MarketRange',
        data() {
            return {
                selectAll: false
            }
        },

        methods: {
            select(index) {
                const marketCap = cloneDeep(this.marketCaps[index]);
                marketCap.selected = !marketCap.selected;

                this.setMarketCap({index, marketCap});

                if (this.marketCaps.filter(item => item.selected).length === this.marketCaps.length) {
                    this.selectAll = true;
                } else {
                    this.selectAll = false;
                }
            },
            setAllActive() {
                const mktCaps = cloneDeep(this.marketCaps);
                if (this.selectAll) {
                    mktCaps.forEach(item => item.selected = false);
                } else {
                    mktCaps.forEach(item => item.selected = true);
                }
                this.selectAll = !this.selectAll;
                this.setMarketCaps(mktCaps);
            },
            ...mapActions(['setMarketCap', 'setMarketCaps'])
        },
        computed: {
            ...mapState(['marketCaps'])
        },
        mounted() {
            if (this.marketCaps.filter(item => item.selected).length === this.marketCaps.length) {
                this.selectAll = true;
            }
        }
    }
</script>
<style lang="less">
    .button-select {
        button {
            min-width: 140px;
            &:nth-child(even) {
                margin-right: 40px;
            }
            &:nth-child(odd) {
                margin-right: 24px;
            }
            &::after {
                background-color: white;
            }
            svg {
                float: right;
            }
            &:hover {
                border-color: #000;
                .fg-positive {
                    color: #000;
                }
            }
        }
    }
    @media (max-width: 992px) {
        .button-select {
            button {
                width: calc(100% - 8px);
                text-align: left;
                margin: 2px 0 8px 0;
                .fg-positive {
                    float: right;
                    padding: 0;
                }
                &:nth-child(even) {
                    margin-right: 0;
                }
                &:nth-child(odd) {
                    margin-right: 0;
                }
            }
        }
    }
    @media (max-width: 600px) {
        .button-select {
            button {
                width: 100%;
            }
        }
    }
</style>
